import { Button, ControlGroup, H4 } from '@blueprintjs/core';
import { Users } from '@just-in-types';
import * as React from 'react';
import styled from 'react-emotion';
import { CheckInsColumnOptions } from '.';
import { assignNiceName } from './helpers';

const Column = styled('div')`
  display: flex;
  flex-direction: column;
`;

interface ModeArr{
  background? : string;
  fontColor? : string;
  mode: string;
  tableBgColor?:string;
  tableBorder?:string;
  tableFontColor?:string;
}

interface Props {
  columnOptions: Users.ColumnOptions[];
  modeArr:ModeArr;
  onUpdateColumnOptions: (
    columnOptions: Users.ColumnOptions[],
    path: CheckInsColumnOptions,
  ) => Promise<void>;
  path: CheckInsColumnOptions;
  title: string;
}

class ColumnPicker extends React.PureComponent<Props, {}> {
  public render() {
    const { columnOptions, title, modeArr } = this.props;

    return (
      <Column>
        <H4>{title}</H4>
        {columnOptions.map(({ enabled, name }, index) => {
          const indexString = index.toString();

          return (
            <ControlGroup key={index} style={{ marginBottom: '0.25rem' }}>
              <span className={'table_option_btn'}>
              <Button
                data-index-string={indexString}
                // intent="primary"
                minimal={!enabled}
                onClick={this.toggleEnabled}
                style={{ width: '7rem', background:modeArr.background, color:modeArr.fontColor }}
                text={assignNiceName(name)}
              />
              </span>
              <Button
                data-index-string={indexString}
                disabled={index === 0}
                icon="chevron-up"
                onClick={this.moveUp}
              />
              <Button
                data-index-string={indexString}
                disabled={index === columnOptions.length - 1}
                icon="chevron-down"
                onClick={this.moveDown}
              />
            </ControlGroup>
          );
        })}
      </Column>
    );
  }

  private updateColumnOptions = async (
    columnOptions: Users.ColumnOptions[],
  ) => {
    const { onUpdateColumnOptions, path } = this.props;

    await onUpdateColumnOptions(columnOptions, path);
    const tableColumBlock =  document.querySelectorAll<HTMLElement>('#chkinwrap_main_block .bp3-table-top-container .table_base, #chkinwrap_main_block .bp3-table-quadrant-scroll-container')!;

    tableColumBlock.forEach((ele)=>{
      ele.style.background = this.props.modeArr.tableBgColor?this.props.modeArr.tableBgColor:'#f5f8fa';
      ele.style.color = this.props.modeArr.tableFontColor?this.props.modeArr.tableFontColor:'#182026';
      ele.style.border = "1px solid "+ this.props.modeArr.tableBorder;
    }); 

  };

  private getColumn = (indexString: undefined | string) => {
    const { columnOptions } = this.props;
    const index = parseInt(indexString || 'n', 10);

    if (!isNaN(index) && columnOptions[index]) {
      const column = columnOptions[index];

      return { column, columnOptions, index };
    }

    return null;
  };

  private toggleEnabled = ({
    currentTarget,
  }: React.MouseEvent<HTMLButtonElement>) => {
    const maybeColumn = this.getColumn(currentTarget.dataset.indexString);


    if (maybeColumn) {
      const { column, columnOptions, index } = maybeColumn;
      const nextOptions = columnOptions.slice();

      nextOptions[index].enabled = !column.enabled;

      this.updateColumnOptions(nextOptions);
    }
  };

  private reorderColumnOptions = (
    columnOptions: Users.ColumnOptions[],
    column: Users.ColumnOptions,
    index: number,
    change: -1 | 1,
  ) => {
    let nextIndex = index + change;

    if (nextIndex < 0) {
      nextIndex = 0;
    } else if (nextIndex >= columnOptions.length) {
      nextIndex = columnOptions.length;
    }

    const nextOptions = columnOptions.slice();
    nextOptions.splice(index, 1);
    nextOptions.splice(nextIndex, 0, column);

    this.updateColumnOptions(nextOptions);
  };

  private moveUp = ({ currentTarget }: React.MouseEvent<HTMLButtonElement>) => {
    const maybeColumn = this.getColumn(currentTarget.dataset.indexString);

    if (maybeColumn) {
      const { column, columnOptions, index } = maybeColumn;

      this.reorderColumnOptions(columnOptions, column, index, -1);
    }
  };

  private moveDown = ({
    currentTarget,
  }: React.MouseEvent<HTMLButtonElement>) => {
    const maybeColumn = this.getColumn(currentTarget.dataset.indexString);

    if (maybeColumn) {
      const { column, columnOptions, index } = maybeColumn;

      this.reorderColumnOptions(columnOptions, column, index, 1);
    }
  };
}

export default ColumnPicker;



// WEBPACK FOOTER //
// ./src/views/CheckIns/ViewOptionsPicker.tsx